import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'
import moment from 'moment'
import { doc } from './common'
import { listings } from './entities'

export let totalIncome = createSelector([doc], application => {
	let res = 0;
	let regexp = /\$|\s|,/g
	let pre = application.primaryResident.employment[0]
	res = res + parseInt(pre.monIncome.replace(regexp, "")) + (pre.otherIncome.length && parseInt(pre.otherIncome.replace(regexp, "")))
	application.additionalResidents.length && application.additionalResidents.forEach(resident => {
		if(resident.age.indexOf("Child") != -1) return
		res = res + parseInt(resident.employment[0].monIncome.replace(regexp, ""))
	})
	return res
})

export let getlistingsByPropertyID = (state, propertyID) => R.values(R.filter(listing => listing.propertyID == propertyID)(listings(state)))[0]



// WEBPACK FOOTER //
// ./src/selectors/application.js